// class DTaledDesignsUiRevolverCarousel {
// 	constructor(element, settings) {
// 		const defaults = {
// 			controls: true,
// 			draggable: true,
// 			frameDirection: 'horizontal',
// 			pagination: true,
// 			unlimited: true,
// 			visibleChambers: 2
// 		};

// 		this.element = element;
// 		this.settings = { ...defaults, ...settings };
// 		this.currentSlide = 0;
// 		this.totalSlides = Math.ceil(this.element.querySelectorAll('.dtaleddesigns-ui-revolver__chamber').length / this.settings.visibleChambers);

// 		// Initializations
// 		this.updateChamberSizes();
// 		this.bindEvents();

// 		// Pagination and Controls
// 		if (this.settings.pagination) {
// 			this.createPagination();
// 		}
// 		if (this.settings.controls) {
// 			this.createControls();
// 		}
// 	}

// 	updateChamberSizes() {
// 		const chamberWidth = this.element.clientWidth / this.settings.visibleChambers;
// 		let tallestHeight = 0;

// 		this.element.querySelectorAll('.dtaleddesigns-ui-revolver__chamber').forEach((chamber, i) => {
// 			chamber.style.width = `${ chamberWidth }px`;
// 			chamber.style.transform = `translateX(${ chamberWidth * i }px)`;

// 			const chamberHeight = chamber.offsetHeight;
// 			if (chamberHeight > tallestHeight) {
// 				tallestHeight = chamberHeight;
// 			}
// 		});

// 		this.element.children[ 0 ].style.height = `${ tallestHeight }px`;
// 		this.element.children[ 0 ].style.width = `${ this.totalSlides * chamberWidth }px`;
// 	}

// 	bindEvents() {
// 		const dragStart = (e) => {
// 			if (!this.settings.draggable) {
// 				return;
// 			}

// 			this.startPos = this.settings.frameDirection === 'horizontal' ? e.pageX : e.pageY;
// 			this.dragging = true;

// 			this.element.addEventListener('mousemove', dragMove);
// 			this.element.addEventListener('mouseup', dragEnd);
// 			this.element.addEventListener('mouseleave', dragEnd);
// 		};

// 		const dragMove = (e) => {
// 			if (!this.dragging) {
// 				return;
// 			}
// 			let currentPos;

// 			if (e.touches && e.touches.length >= 0) {
// 				currentPos = e.touches[ 0 ].clientX;
// 			} else {
// 				currentPos = e.clientX;
// 			}
// 			const distanceDragged = this.startPos - currentPos;

// 			if (distanceDragged > 50) {
// 				this.startPos = currentPos;
// 				if (this.settings.unlimited || this.currentSlide < this.totalSlides - 1) {
// 					this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
// 				}
// 				this.updateChamberPosition();
// 			} else if (distanceDragged < -50) {
// 				this.startPos = currentPos;
// 				if (this.settings.unlimited || this.currentSlide > 0) {
// 					this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
// 				}
// 				this.updateChamberPosition();
// 			}
// 		};

// 		const dragEnd = () => {
// 			this.dragging = false;

// 			this.element.removeEventListener('mousemove', dragMove);
// 			this.element.removeEventListener('mouseup', dragEnd);
// 			this.element.removeEventListener('mouseleave', dragEnd);
// 		};

// 		const debounce = (func, delay) => {
// 			let debounceTimer;
// 			return function() {
// 				const context = this;
// 				const args = arguments;
// 				clearTimeout(debounceTimer);
// 				debounceTimer = setTimeout(() => func.apply(context, args), delay);
// 			};
// 		};
// 		this.element.addEventListener('touchstart', dragStart, { passive: true });
// 		this.element.addEventListener('touchmove', dragMove, { passive: true });
// 		this.element.addEventListener('touchend', dragEnd, { passive: true });
// 		this.element.addEventListener('mousedown', dragStart, { passive: true });
// 		this.element.addEventListener('mousemove', dragMove, { passive: true });
// 		this.element.addEventListener('mouseup', dragEnd, { passive: true });

// 		window.addEventListener('resize', debounce(() => {
// 			this.updateChamberSizes();
// 			this.updateChamberPosition();
// 		}, 250));
// 	}

// 	updateSlidePosition(clientX) {
// 		const diffX = this.startX - clientX;
// 		if (diffX > 0) { // Swipe Left or Mouse Drag Left
// 			this.currentSlide ++;
// 		} else if (diffX < 0) { // Swipe Right or Mouse Drag Right
// 			this.currentSlide--;
// 		}
// 		this.updateChamberPosition();
// 	}

// 	updateChamberPosition() {
// 		const chamberWidth = this.element.querySelector('.dtaleddesigns-ui-revolver__chamber').clientWidth;
// 		this.element.children[ 0 ].style.transform = `translateX(-${ chamberWidth * this.currentSlide }px)`;
// 	}

// 	createPagination() {
// 		const pagination = document.createElement('ul');
// 		pagination.classList.add('dtaleddesigns-ui-pagination');

// 		for (let i = 0; i < this.totalSlides; i ++) {
// 			const listItem = document.createElement('li');
// 			listItem.dataset.slide = i;
// 			listItem.addEventListener('click', () => {
// 				this.currentSlide = i;
// 				this.updateChamberPosition();
// 			});
// 			pagination.appendChild(listItem);
// 		}

// 		this.element.appendChild(pagination);
// 	}

// 	createControls() {
// 		const prevButton = document.createElement('button');
// 		prevButton.classList.add('dtaleddesigns-ui-prev');
// 		prevButton.addEventListener('click', () => {
// 			if (this.currentSlide > 0 || this.settings.unlimited) {
// 				this.currentSlide--;
// 				if (this.currentSlide < 0) {
// 					this.currentSlide = this.totalSlides - 1;
// 				}
// 				this.updateChamberPosition();
// 			}
// 		});

// 		const nextButton = document.createElement('button');
// 		nextButton.classList.add('dtaleddesigns-ui-next');
// 		nextButton.addEventListener('click', () => {
// 			if (this.currentSlide < this.totalSlides - 1 || this.settings.unlimited) {
// 				this.currentSlide ++;
// 				if (this.currentSlide >= this.totalSlides) {
// 					this.currentSlide = 0;
// 				}
// 				this.updateChamberPosition();
// 			}
// 		});

// 		this.element.appendChild(prevButton);
// 		this.element.appendChild(nextButton);
// 	}
// }

// HTMLDivElement.prototype.dtaleddesignsUiRevolverCarousel = function(settings) {
// 	return new DTaledDesignsUiRevolverCarousel(this, settings);
// };

class DTaledDesignsUiRevolverCarousel {
	constructor(element, settings) {
		console.log(element);
	}
}

HTMLDivElement.prototype.dtaleddesignsUiRevolverCarousel = function(settings) {
	return new DTaledDesignsUiRevolverCarousel(this, settings);
};
